import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPaperPlane: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconPaperPlane"><Path d="M5.99931 12H9.24931M5.99931 12L3.45371 5.63604C2.94282 4.3588 4.27717 3.12491 5.5106 3.73401L19.5258 10.6551C20.6402 11.2054 20.6402 12.7946 19.5258 13.345L5.5106 20.2661C4.27718 20.8752 2.94282 19.6413 3.45371 18.364L5.99931 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconPaperPlane;
